import React, { useState, useRef, useEffect } from "react";

import LayoutCard from "../../Layout/Layout";

import CompareSvg from "../../../../images/compare-assessment.svg"


import FilterOption from "./FilterOption/index.jsx";
import ReportChartComponent from "./Report-charts/index.jsx";

const AssessmentsReport = () => {
  const [reload, setReload] = useState(false);


  return (
    <LayoutCard
      headerIcon={CompareSvg}
      headerText="Compare Assessments"
      reportPage={true}
      reload={reload}
    >
      <FilterOption setReload={setReload} />
      <ReportChartComponent reload={reload} />
    </LayoutCard>
  );
};

export default AssessmentsReport;



// WEBPACK FOOTER //
// ./src/new/Components/Reports/Assessment-Reports/Asssessment-Report.jsx